import { render, staticRenderFns } from "./Procedures.vue?vue&type=template&id=7d464199&scoped=true&"
import script from "./Procedures.vue?vue&type=script&lang=js&"
export * from "./Procedures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d464199",
  null
  
)

export default component.exports